import React, { Component } from "react";
import { NonIdealState, Button } from "@blueprintjs/core";
import { navigate } from "../../../store/navigation/operations";
import { connect } from "react-redux";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { Translate, I18n } from "react-redux-i18n";
import { isLoadingNotifications, getNotifications } from "../../../store/app_notifications/selectors";
import { fetchNotifications, markAsRead } from "../../../store/app_notifications/operations";
import NotificationItem from "../../../components/notifications/NotificationItem";
import ReduxLinkDecorator from "../../../containers/ReduxLinkDecorator";

export class NotificationsList extends Component {
  constructor(props) {
    super(props);
    this.notificationClicked = this.notificationClicked.bind(this);
  }

  componentDidMount() {
    this.props.fetchNotifications();
  }
  notificationClicked(notification) {
    //TODO: here we shoud check the notification type and deppending on that to redirect to the right place
    this.props.markAsRead(notification["u_guid"], notification["c_at"]);
    this.props.navigate(`/circle-toolbox/${notification["ref"]}`);
  }
  render() {
    return (
      <section className="gray-bg">
        {this.props.loading && <LoadingIndicator />}
        {!this.props.loading && (
          <div className="main-container">
            <div className="content-wrapper">
              {this.props.notifications.length === 0 && (
                <div className="custom-card">
                  <NonIdealState
                    icon="notifications"
                    title={I18n.t("notifications.no_notifications")}
                    description={I18n.t("notifications.setup_circle")}
                    action={
                      <ReduxLinkDecorator goTo="new-circle">
                        <Button intent="primary" fill={false}>
                          <Translate value="notifications.create_circle" />
                        </Button>
                      </ReduxLinkDecorator>
                    }
                  />
                  <div className="spacer-16" />
                </div>
              )}
              {this.props.notifications.length > 0 && (
                <div className="custom-card notification-container">
                  <div className="header">
                    <h1>
                      <Translate value="notifications.title" />
                    </h1>
                  </div>
                  <div className="notification-listing full-page">
                    {this.props.notifications.map((notification) => (
                      <NotificationItem
                        key={notification.c_at}
                        notification={notification}
                        onClick={this.notificationClicked}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loading: isLoadingNotifications(state),
    notifications: getNotifications(state),
    locale: state.i18n.locale,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchNotifications: (id) => dispatch(fetchNotifications()),
  markAsRead: (u_guid, c_at) => dispatch(markAsRead(u_guid, c_at)),
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
